module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [_c('defs', [_c('circle', {
    attrs: {
      "id": "a",
      "cx": "40",
      "cy": "40",
      "r": "40"
    }
  })]), _c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('mask', {
    attrs: {
      "id": "b",
      "fill": "#fff"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#a"
    }
  })]), _c('use', {
    attrs: {
      "fill": "#F9E9CB",
      "fill-rule": "nonzero",
      "xlink:href": "#a"
    }
  }), _c('g', {
    attrs: {
      "mask": "url(#b)",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(4.78 7.16)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M34.99 43.83c-30.8 0-17.52-24.42-17.52-24.42C17.47 9.21 25.39.93 35.14.93 44.9.93 52.8 9.21 52.8 19.41c0 0 12.98 24.42-17.81 24.42z",
      "fill": "#7F7F7F"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FEBE8C",
      "d": "M19.84 47.08l9.19-3.8h12.4l6.65 3.23v25.38H19.84z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FEBE8C",
      "d": "M28.96 77.72h12.62L43 70.24l-1.05-40.1-6.94.43h-7.26l.45 39.84z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#627680",
      "d": "M41.05 77.72l3.28-24.05L35 51.94l-9.04 1.8 2.7 23.98z"
    }
  }), _c('path', {
    attrs: {
      "d": "M59.33 77.72c.08-.59 2.9-25.96 2.9-25.96L46.7 45.13 34.88 77.72h24.45z",
      "fill": "#A2AFB5"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M35.02 51.94a11.07 11.07 0 01-10.85-4.78l3.04 13.35c3.53-.9 6.42-3.42 7.81-6.78a12.18 12.18 0 007.82 6.76l3.05-13.35a11.07 11.07 0 01-10.87 4.8z",
      "fill": "#BFBFBF"
    }
  }), _c('path', {
    attrs: {
      "d": "M43.58 43.83c-.44.97-2.39 7.64-8.71 8.05 0 1.85 4.26 7.06 9.3 4.24C49.24 53.3 47 45.1 47 45.1l-3.42-1.28z",
      "fill": "#627680"
    }
  }), _c('path', {
    attrs: {
      "d": "M26.5 43.8c.45.99 2.4 7.66 8.72 8.07 0 1.81-4.26 7.04-9.27 4.26-5.02-2.78-2.82-11.02-2.82-11.02l3.38-1.3z",
      "fill": "#627680"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M38.91 77.72L53.1 58.99l-6.2-3.83a22.2 22.2 0 006.7-1.5c-1.03-4.6-6.9-8.53-6.9-8.53L34.96 77.72h3.95z",
      "fill": "#BFBFBF"
    }
  }), _c('path', {
    attrs: {
      "d": "M38.6 77.72a1006 1006 0 0012.92-20.13L46.9 55.2a24.84 24.84 0 014.62-2.66c-.69-6.45-4.77-8.36-4.77-8.36L34.8 77.6l3.8.1z",
      "fill": "#A2AFB5"
    }
  }), _c('path', {
    attrs: {
      "d": "M11.24 77.72h23.7L23.14 45.13l-14.9 6.63S9.65 68.14 11 76.74c.1.32.17.65.24.98z",
      "fill": "#A2AFB5"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M22.93 55.16l-5.62 3.77s5 7.02 13.73 18.79h3.38L22.7 45.6s-4.9 3.9-5.97 8.5c1.96.8 4.08 1.16 6.2 1.06z",
      "fill": "#BFBFBF"
    }
  }), _c('path', {
    attrs: {
      "d": "M18.71 57.31s5.17 8.8 12.6 20.4h3.7L23.07 44.44s-4.2 1.03-4.78 8.13c1.64.7 3.19 1.57 4.64 2.6l-4.22 2.15zM12.32 77.72l-4.1-25.96S2.2 58.58 1.07 77.72h11.26zM58.13 77.72l4.1-25.96s5.96 6.82 7.16 25.96H58.13z",
      "fill": "#A2AFB5"
    }
  }), _c('ellipse', {
    attrs: {
      "fill": "#C28B60",
      "cx": "35.04",
      "cy": "32.11",
      "rx": "9.1",
      "ry": "10.24"
    }
  }), _c('path', {
    attrs: {
      "d": "M23.98 28.38c0 .9.1 1.5-.58 1.63-.68.12-1.68.34-1.75-1.64 0-2.13-.15-4.27-.47-6.38 0-.88.7-1.98 1.48-1.99a1.46 1.46 0 011.4 1.58l-.08 6.8z",
      "fill": "#E6B693"
    }
  }), _c('path', {
    attrs: {
      "d": "M46.11 28.38c0 .9-.1 1.5.56 1.63.67.12 1.7.34 1.76-1.64 0-2.13.16-4.27.48-6.38 0-.88-.7-1.98-1.48-1.99a1.46 1.46 0 00-1.4 1.58l.08 6.8z",
      "fill": "#FEBE8C"
    }
  }), _c('path', {
    attrs: {
      "d": "M35.04 9.1a12.04 12.04 0 00-12.03 12.02v7.54A12.04 12.04 0 0035.04 40.7V9.1z",
      "fill": "#E6B693"
    }
  }), _c('path', {
    attrs: {
      "d": "M35.04 9.1v12.94a10.5 10.5 0 01-2.74 6.84c-1.5 1.85 1.37 3.23 2.74 3.23a2.53 2.53 0 01-1.1 1.84c.48.6-.17 1.55-.2 1.94.47.55.9 1.12 1.3 1.73a1.59 1.59 0 00-1.77 1.41 1.62 1.62 0 001.77 1.67 12.02 12.02 0 0012.03-12.04v-7.54c0-6.64-5.38-12.02-12.03-12.02z",
      "fill": "#E6B693"
    }
  }), _c('path', {
    attrs: {
      "d": "M34.96 33.31c-1.64.05-3.28-.17-4.85-.65a.32.32 0 00-.4.4 5.39 5.39 0 0010.5 0 .3.3 0 00-.37-.4c-1.58.47-3.23.68-4.88.65z",
      "fill": "#B0573E"
    }
  }), _c('path', {
    attrs: {
      "d": "M30.58 32.8c.13.78.7 2.39 4.38 2.39 3.7 0 4.44-1.76 4.51-2.46-1.47.4-2.98.6-4.5.58-1.49.03-2.96-.14-4.4-.51z",
      "fill": "#FFF"
    }
  }), _c('path', {
    attrs: {
      "d": "M34.96 33.31c-1.48.03-2.95-.14-4.38-.51v.17l.07.2.08.22c1.33.5 2.75.71 4.17.64a9.97 9.97 0 004.31-.74v-.1c.04-.1.08-.2.1-.32v-.17c-1.41.4-2.88.6-4.35.61z",
      "fill": "#C4C4C4"
    }
  }), _c('path', {
    attrs: {
      "d": "M29.5 19.98a7.56 7.56 0 013.59.86 4.64 4.64 0 00-3.82-2.18 4.78 4.78 0 00-4.14 2.71 7.06 7.06 0 014.37-1.4zM40.6 19.98a7.55 7.55 0 00-3.59.86 4.64 4.64 0 013.83-2.18 4.78 4.78 0 014.13 2.71 7.07 7.07 0 00-4.37-1.4z",
      "fill": "#7F7F7F"
    }
  }), _c('path', {
    attrs: {
      "d": "M23.08 23.7C24.18 18.93 27.95 11 39.98 11c4.77 3.41 6.05 6.9 6.74 12.47 5.85-13.13-5.66-17.1-11.75-17.1S17.2 9.32 23.08 23.7z",
      "fill": "#7F7F7F"
    }
  }), _c('circle', {
    attrs: {
      "fill": "#FAFAFA",
      "cx": "35.02",
      "cy": "60.13",
      "r": "1.06"
    }
  }), _c('circle', {
    attrs: {
      "fill": "#FAFAFA",
      "cx": "35.02",
      "cy": "67.92",
      "r": "1.06"
    }
  })])]), _c('path', {
    attrs: {
      "d": "M47.08 32.24a.66.66 0 01-.72.58.66.66 0 01-.7-.58v-1.61a.67.67 0 01.7-.6c.37-.03.68.24.72.6v1.6z",
      "fill": "#3E2D1E",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M46.83 31.04c0 .22-.1.39-.23.39-.12 0-.24-.17-.24-.39 0-.21.11-.37.24-.37s.23.18.23.37z",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M33.98 32.24a.64.64 0 01-.7.58.64.64 0 01-.7-.58v-1.61a.66.66 0 01.7-.6c.36-.03.67.24.7.6v1.6z",
      "fill": "#3E2D1E",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M33.81 31.04c0 .22-.1.39-.22.39-.13 0-.23-.17-.23-.39 0-.21.1-.37.23-.37s.22.18.22.37z",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M47.13 27.94c-3.19 0-5.06.55-5.82 1.2a3.73 3.73 0 00-2.27-.6c-.49.05-.96.23-1.36.53-.78-.65-2.64-1.19-5.73-1.19-4.03 0-6.2 1.02-6.2 1.97 0 1.92.38 6.39 3.93 6.39 3.37 0 5.77-.68 7.17-2.02a5.13 5.13 0 001.36-4.15c.25-.3.61-.48 1-.5a2.7 2.7 0 011.8.56v.07a5.07 5.07 0 001.32 4.08c1.36 1.34 3.76 2.02 7.16 2.02 3.4 0 3.94-4.47 3.94-6.39-.1-.95-2.28-1.97-6.3-1.97zm-11.06 5.65c-1.2 1.2-3.3 1.73-6.39 1.73-2.59 0-2.9-3.69-2.91-5.35.26-.31 1.83-1.05 5.18-1.05 3.88 0 5.06.82 5.16.99v.32a4.18 4.18 0 01-1.04 3.36zm13.33 1.73c-3.1 0-5.24-.59-6.4-1.73a4.2 4.2 0 01-1.04-3.36v-.26c.1-.23 1.29-1.05 5.17-1.05 3.35 0 4.92.75 5.17 1.05 0 1.66-.31 5.35-2.9 5.35z",
      "fill": "#534741",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1334fdd7","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/components/avatar/components/stub/components/oldwoman/MentoringOldWomanIcon.vue
// module id = 85f682ece9a82ecd1e77
// module chunks = 89